<template>
	<div
		v-loading="loading"
		class="index"
	>
		<div v-for="(item,index) in indexData" :key="index">
			<banner :componentId="item.id" v-if="Number(item.type)==11"></banner>
			<modularOne :componentId="item.id" :componentType="item.type" v-if="Number(item.type)==4"></modularOne>
			<modularTwo :componentId="item.id" :componentType="item.type" v-if="Number(item.type)==14"></modularTwo>
			<modularThree :componentId="item.id" :componentType="item.type" v-if="Number(item.type)==18"></modularThree>
			<modularFour :componentId="item.id" :componentType="item.type" v-if="Number(item.type)==17"></modularFour>
			<comIndex19 :componentId="item.id" :componentType="item.type" v-if="Number(item.type)==19"></comIndex19>
			<!-- <template
				v-if="![11,4,14,18,17].find(val => val === Number(item.type))"
			>
				<h2
					style="margin: auto;"
				>
					没有对应组件！type：{{item.type}}
				</h2>
			</template> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import modularOne from "./modular/modular_one.vue"
	import modularTwo from "./modular/modular_two.vue"
	import modularThree from "./modular/modular_three.vue"
	import modularFour from "./modular/modular_four.vue"
	import comIndex19 from "./modular/comIndex19.vue"
	import banner from "./modular/banner.vue"
	import { mapGetters } from 'vuex'
	export default {
		name:"Index",
		components:{
			modularOne,
			modularTwo,
			modularThree,
			modularFour,
			banner,
			comIndex19,
		},
		data() {
			return {
				loading: false,
				car_num: 0,
				indexData:[]
			}
		},
		computed: {
			...mapGetters([
				'userInfo'
			])
		},
		created(){
			this.getData() 
			this.$store.commit('setPageHead', {
				content: this.$t('common.pageHead.index'),
				isShow: false
			})
		},
		methods: {
			getData(){
				this.loading = true
				this.$server.post("/index.php/AppInterface/Index/index", {
					token: this.userInfo.token,
				})
				.then(res => {
					this.loading = false
					switch (res.result){
						case 1:
							this.indexData = res.data.index_arr||[] 
							console.log(this.indexData)
							for(let [index, item] of this.indexData.entries()) {
								if(! [11, 4, 14, 18, 17, 19].find(val => val === Number(item.type))) {
									console.log(`type[${index}] => ${item.type} 没有对应组件！`)
								}
								else {
									console.log(`type[${index}] => ${item.type}`)
								}
							}
							break;
						default:
							this.$message.warning(res.msg)
							break;
					}
				})
				.catch(err => { 
					this.loading = false
					this.$message.error(this.$t('common.require-error'))
				})
			}
		}
	}
</script>

<style lang="scss">   
	.index{
		
	}
</style>



// WEBPACK FOOTER //
// src/components/index.vue